/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Container, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import TextInput from "../../components/TextField/TextField";
import { useForm } from "react-hook-form";
import NumberInput from "../../components/NumberBox/NumberBox";
import Loader from "../../components/Loader/Loader";

const ViewCoffeeCreditPopup = React.memo(
  ({ userDetails, handleClose, setIsUpdated }) => {
    const { dashboardStyle } = useContext(TableContext);
    const { formthemeStyle, bodyheader, viewformStyle } =
      useContext(TableContext);
    const dispatch = useDispatch();
    const params = useParams();
    const token = `Bearer ${getCookies("Token")}`;
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(userDetails);

    const navigate = useNavigate();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const {
      control,
      register,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm();
    function onSubmitdata(data) {
      const apiData = {
        userId: userDetails?.id,
        coffeeCount: data.coffee,
      };
      data.actionUrl = "user/add-coffee";
      data.actionMethod = "post";
      data.apiData = apiData;
      dispatch(Entry(data)).then((resp) => {
        if (resp.payload.code === 200) {
          setIsUpdated(true);
          handleClose();
          toast.success("Coffee credits added successfull");
        } else if (resp.payload.code === 401 || resp.payload.code === 400) {
          // setError(resp.payload.message);
          toast.error(resp?.payload?.message);
        } else {
          // setError('Something went wrong!');
        }
      });
    }
    return (
      <div className={styles.popupbox}>
        <div className={styles[formthemeStyle]} id={styles.box}>
          <span
            className={styles.closeicon}
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyPress={handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </span>
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "300px", // adjust height as needed
                width: "100%",
              }}
            >
              <Loader />
            </div>
          ) : (
            <Container fluid>
              <form onSubmit={handleSubmit(onSubmitdata)}>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <NumberInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      labelstyle={styles.formlabel}
                      label="Coffee Reward Count"
                      placeHolder="Enter Coffee Reward"
                      fieldName="coffee"
                      // validation={discountValidation}
                      register={register}
                      errors={errors}
                      isRequired
                      defaultValue={details?.coffee || 0}
                      // mandatory
                    />
                  </div>
                </div>

                <div className="d-flex mt-2">
                  <input
                    className={styles.formbtn}
                    type="submit"
                    // disabled={submiting}
                    value="Submit"
                  />
                </div>
                <br />
              </form>
            </Container>
          )}
        </div>
      </div>
    );
  }
);

export default ViewCoffeeCreditPopup;
